package ui.widget

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.width
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Slider
import androidx.compose.material3.SliderDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import compose.assets.Svg
import compose.assets.svg.Volume_high
import org.jetbrains.compose.resources.StringResource
import ssoft.frontend.generated.resources.Res
import ssoft.frontend.generated.resources.layer_top_detail__enable_audio
import ssoft.frontend.generated.resources.layer_top_detail_editor__audio_setup_title
import tools.EFieldDualIntAsFloat
import tools.EFieldRegularBoolean
import kotlin.math.roundToInt

private var volumeEnabledField = false

@Composable
fun EditorCardVolumeSetup(
    field: EFieldDualIntAsFloat,
    tooltip: StringResource,
    modifier: Modifier = Modifier
) {

    val volumeEnabled = remember {
        volumeEnabledField = field.state > 0F
        EFieldRegularBoolean(
            property = ::volumeEnabledField,
            onChange = {
                if (it) field.set(0.5F)
                else field.set(0F)
            })
    }

    EditorCardWrapper(
        icon = Svg.Volume_high,
        title = Res.string.layer_top_detail_editor__audio_setup_title,
        tooltip = tooltip,
        modifier = modifier
    ) {
        SwitchCard(
            field = volumeEnabled,
            label = Res.string.layer_top_detail__enable_audio
        )

        AnimatedVisibility(
            visible = volumeEnabled.state,
            modifier = Modifier.fillMaxWidth()
        ) {
            Row {
                Slider(
                    value = field.state,
                    modifier = Modifier.weight(1F)
                        .align(Alignment.CenterVertically),
                    colors = SliderDefaults.colors(
                        inactiveTrackColor = MaterialTheme.colorScheme.inverseSurface,
                    ),
                    onValueChange = {
                        field.set(it)
                    })
                Text(
                    text = "${(field.state * 100F).coerceIn(0F, 100F).roundToInt()}%",
                    textAlign = TextAlign.Center,
                    modifier = Modifier.width(64.dp)
                        .align(Alignment.CenterVertically)
                )
            }
        }
    }
}